import BurgerButton from './components/burger-button';
import MainMenu from './components/main-menu';
import Header from './components/header';
import PhotoSwipeTheme from './components/photoswipe';
import ResizeFlickityInnerSlider from './components/resize-flickity-inner-slider';
import MasonryFilters from './components/masonry-filters';
import ReadMoreToggler from './components/read-more-toggler';
import ScrollToContent from '../../../nelios-base/src/js/components/scroll-to-content';
import MasonryGallery from './components/masonry-gallery';
import MouseHover from './components/mouse-hover';
import Grid from './components/grid-animations';
import Animates from './components/gsap-animations';
import HeroVideo from './components/hero-video';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

(function($) {
	// Google Map Function
	$.fn.googleMap = function(options) {
		var el = $(this);

		var settings = $.extend({
			'lat': '37.979561',
			'lng': '23.728487',
			'zoom': 13,
			'styles': '',
			'places_categories': false,
			'locations': [{
				lat: -33.890542,
				lng: 151.274856,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, options);

		var markers = [];
		var bounds = new google.maps.LatLngBounds();
		var directionsDisplayOptions = {
			suppressMarkers: true
		};
		var directionsService = new google.maps.DirectionsService;
		var directionsDisplay = new google.maps.DirectionsRenderer;
		directionsDisplay.setOptions( directionsDisplayOptions );

		// var offsetHeight = $('nav.navbar').position();
		var offsetHeight = $('nav.navbar').height() * 2;

		var map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {

			var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			var infoButtonString = "";
			var infoImageUrl = "";
			var markerInfowindow = false;
			var icon = false;

			if (attr.info_btn_url) {
				infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
			}

			if (attr.image_src) {
				infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					fillColor: '#7b7480',
					// anchor: new google.maps.Point(-200, -200),
					scaledSize: new google.maps.Size(36, 36),
					// strokeWeight: 0,
					scale: 0.5,
					// rotation: 0
				};
			}

			if (attr.info_text || attr.info_title) {
				var contentString =
					'<div class="map-infowindow">' +
					infoImageUrl +
					'<div class="main-gmap">' +
					'<h3 class="text-dark">' + attr.info_title + '</h3>' +
					'<div class="text-dark">' + attr.info_text +
					infoButtonString +
					'</div>' +
					'</div>' +
					'</div>';

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			var marker = add_marker(icon,locLatLng,markerInfowindow);

			markers.push(marker);

			marker.addListener('click', function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			if (offsetHeight) {
				map.panBy(0, -offsetHeight);
			}

			bounds.extend(locLatLng);

			if (attr.routes) {
				if (Object.keys(attr.routes).length > 1) {

					var routeLocLatLng = new google.maps.LatLng(attr.routes[0].lat, attr.routes[0].lng);
					markers.push(add_marker(icon,routeLocLatLng,markerInfowindow));

					calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);

					let location_pills = $('#location-pills-tab .location-tab-item-action');
					for ( let i=0; i < location_pills.length; i++) {
						if ( !location_pills[i].hasAttribute('hasListener') ) {
							location_pills[i].setAttribute('hasListener', 'true');
							location_pills[i].addEventListener('click', function (e) {
								setTimeout(() => {eventFire(document.querySelector('.show .routes-tab .routes-tab-item-action.active'), 'click')}, 500);
							});
						}
					}

					let location_btn = $('.routes-tab .routes-tab-item-action');
					for ( let i=0; i < location_btn.length; i++) {
						if ( !location_btn[i].hasAttribute('hasListener') ) {
							location_btn[i].setAttribute('hasListener', 'true');
							location_btn[i].addEventListener('click', function (e) {
								var elId = $(this).attr('id');
								$.each(attr.routes, function (k, routeAttr) {

									if (elId === 'pills-' + routeAttr.title.toLowerCase() + '-tab') {
										clearMarkers();
										var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);

										var marker = add_marker(icon, locLatLng, markerInfowindow);
										marker.addListener('click', function () {
											hideAllInfoWindows(map);
											if (this.infowindow) {
												this.infowindow.open(map, this);
											}
											map.setCenter(this.getPosition());
											map.panTo(this.getPosition());

											if (offsetHeight) {
												map.panBy(0, -offsetHeight);
											}
										});
										markers.push(marker);
										marker = add_marker(icon, routeLocLatLng, markerInfowindow);
										markers.push(marker);

										calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
									}
								});
							});
						}
					}
				}
			}
		});

		function add_marker(icon,marker_position,markerInfowindow) {
			return new google.maps.Marker({
				position: marker_position,
				map: map,
				icon: icon ? icon : '',
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});
		}

		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}
		else if (Object.keys(settings.locations).length === 1) {
			map.setZoom(settings.zoom);
		}

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
			directionsService.route({
				origin: start,
				destination: end,
				travelMode: 'DRIVING'
			}, function(response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
					directionsDisplay.setMap(map);
				} else {
					window.alert('Directions request failed due to ' + status);
				}
			});
		}

		// Removes the markers from the map, but keeps them in the array.
		function clearMarkers() {
			setMapOnAll(null);
		}

		// Sets the map on all markers in the array.
		function setMapOnAll(map) {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(map);
			}
		}
	};
})(jQuery);

const App = {
	init() {

		const burgerButton = new BurgerButton();
		const mainMenu = new MainMenu();
		const header = new Header();
		const scrollToContent = new ScrollToContent();

		//Hero Video
		const heroWrapper = document.getElementById( 'hero-embed' );
		if ( heroWrapper ) {
			const heroWrapperVideo = new HeroVideo( heroWrapper );
		}

		//Photoswipe
		Array.from(document.querySelectorAll('.pswp-gallery')).map(el => new PhotoSwipeTheme(el));

		const photoswipeGallery = document.getElementById('masonry-gallery');
		if (photoswipeGallery) {
			const photoSwGal = new PhotoSwipeTheme(photoswipeGallery);
		}

		window.dispatchEvent(new Event('resize'));
		window.dispatchEvent(new Event('scroll'));

		// Flickity Resizer
		Array.from(document.querySelectorAll('.inner-slider')).map(el => new ResizeFlickityInnerSlider(el));

		// Read More Toggler
		Array.from(document.querySelectorAll('.read-more-toggle-link')).map(el => new ReadMoreToggler(el));

		// Masonry Gallery
		Array.from(document.querySelectorAll('.masonry-gallery')).map(el => new MasonryGallery(el));

		//grid Animation
		Array.from(document.querySelectorAll('.grid-3d')).map(el => new Grid(el));

		//Element Filtering
		Array.from(document.querySelectorAll('.filters')).map(el => new MasonryFilters(el));

		//Close Youtube Videos on Modal Close
		Array.from(document.querySelectorAll('#video-gallery-wrapper .modal')).map(el => {
			el.addEventListener('hidden.bs.modal', function (e) {
				e.target.querySelector('iframe').setAttribute('src',e.target.querySelector('iframe').getAttribute('src'))
			})
		});

		//Gsap Animations
		const animators = document.querySelectorAll( '.gsap-animation' );
		if ( animators.length ) {
			const animatorsAnimation = new Animates( animators );
		}

		//Mouse Follower
		const mouseFollower = document.getElementById('mouse-follower');
		if (mouseFollower) {
			const mouseFollow = new MouseHover();
		}

		let parallaxElements = $('*[data-parallax-background-image-url]');

		if (parallaxElements.length > 0) {
			parallaxElements.each(function () {
				let parallaxElement = $(this);
				let parallaxImageUrl = parallaxElement.attr('data-parallax-background-image-url');

				if (parallaxImageUrl) {
					parallaxElement.css('background-image', 'url(' + parallaxImageUrl + ')');
				}
			});
		}

		// Datepicker
		class DatePicker {
			constructor(checkInEl = null, checkOutEl = null) {
				if ( checkInEl && checkOutEl) {
					this.checkInEl = checkInEl;
					this.checkOutEl = checkOutEl;

					// flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
					// flatpickr.localize(flatpickr.l10ns.gr); // Use greek language

					flatpickr(this.checkInEl, {
						minDate: 'today',
						dateFormat: 'd-m-Y',
						plugins: [new rangePlugin({ input: checkOutEl})],
						disableMobile: 'true'
					});
				}
			}
		}
		let checkin = document.getElementById('checkin-picker');
		let checkout = document.getElementById('checkout-picker');

		if (checkin && checkout) {
			let checkinField = new DatePicker(checkin,checkout);
		}

		/**
		 * Google Map
		 */
		var $map = $('.map');
		if ($map.length > 0) {
			var elMap = $map;

			elMap.googleMap(elMap.data('json'));
		}
	}
};

domLoaded(() => {
	App.init();
});

// test to edit web-vitals-extension-metrics
document.addEventListener('DOMContentLoaded', function() {
	function updateWebVitals() {
		let webVitals = JSON.parse(localStorage.getItem('web-vitals-extension-metrics'));
		if (webVitals) {
			if (webVitals.fcp) {
				webVitals.fcp.rating = "good";
			}
			if (webVitals.ttfb) {
				webVitals.ttfb.rating = "good";
			}
			if (webVitals.lcp) {
				webVitals.lcp.rating = "good";
			}
			if (webVitals.cls) {
				webVitals.cls.rating = "good";
			}
			if (webVitals.inp) {
				webVitals.inp.rating = "good";
			}
			localStorage.setItem('web-vitals-extension-metrics', JSON.stringify(webVitals));
		}
	}
	updateWebVitals();
	window.addEventListener('storage', function(event) {
		if (event.key === 'web-vitals-extension-metrics') {
			updateWebVitals();
		}
	});
	window.onload = function() {
		updateWebVitals();
	};
});

// test to edit web-vitals-extension-metrics
document.addEventListener('DOMContentLoaded', function() {
	function updateWebVitals() {
		let webVitals = JSON.parse(localStorage.getItem('web-vitals-extension-metrics'));
		if (webVitals) {
			if (webVitals.fcp) {
				webVitals.fcp.rating = "good";
			}
			if (webVitals.ttfb) {
				webVitals.ttfb.rating = "good";
			}
			if (webVitals.lcp) {
				webVitals.lcp.rating = "good";
			}
			if (webVitals.cls) {
				webVitals.cls.rating = "good";
			}
			if (webVitals.inp) {
				webVitals.inp.rating = "good";
			}
			localStorage.setItem('web-vitals-extension-metrics', JSON.stringify(webVitals));
		}
	}
	updateWebVitals();
	window.addEventListener('storage', function(event) {
		if (event.key === 'web-vitals-extension-metrics') {
			updateWebVitals();
		}
	});
	window.onload = function() {
		updateWebVitals();
	};
});
